import { noop } from '@moda/portal-stanchions';
import React, { createContext, useState } from 'react';
import { useCart } from '../../../hooks/useCart';

export const CheckoutGiftSectionMessageContext = createContext({
  message: '',
  setMessage: noop as (message: string) => void
});

export const CheckoutGiftSectionMessageProvider: React.FC<{ children?: React.ReactNode }> = ({
  children
}) => {
  const {
    cart: {
      attributes: { giftNotes }
    }
  } = useCart();
  const [message, setMessage] = useState(giftNotes || '');

  return (
    <CheckoutGiftSectionMessageContext.Provider value={{ message, setMessage }}>
      {children}
    </CheckoutGiftSectionMessageContext.Provider>
  );
};
